// extracted by mini-css-extract-plugin
export var adjacentSlide = "_s1-9";
export var arrowButtonContainer = "_s1-5";
export var arrowButtonIcon = "_s1-6";
export var carouselArrowButton = "_s1-2";
export var carouselElementContainer = "_s1-1";
export var currentSlide = "_s1-8";
export var left = "_s1-3";
export var otherSlide = "_s1-a";
export var productCarouselContainer = "_s1-0";
export var right = "_s1-4";
export var sliderOverflow = "_s1-7";